import React, { useState } from "react";
import { cn } from "@/lib/utils";
import { playerPhotoUrl } from "@/lib/api";

const initials = (first, last, web) => {
  if (first && last) return `${first[0]}${last[0]}`.toUpperCase();
  const s = web || "";
  return s.slice(0, 2).toUpperCase();
};

const colorForCode = (code) => {
  if (!code) return "hsl(220 10% 22%)";
  const hues = [149, 47, 210, 280, 348, 20];
  return `hsl(${hues[code % hues.length]} 60% 30%)`;
};

export default function PlayerAvatar({ player, size = 44, className, showRing = false }) {
  const [error, setError] = useState(false);
  const url = playerPhotoUrl(player?.photo_code || player?.code);

  const style = { width: size, height: size };
  const bg = colorForCode(player?.code);

  if (!url || error) {
    return (
      <span
        className={cn(
          "inline-grid place-items-center rounded-full font-semibold text-totem-text",
          showRing && "ring-2 ring-totem-gold",
          className
        )}
        style={{ ...style, background: bg, fontSize: Math.max(11, size / 2.6) }}
      >
        {initials(player?.first_name, player?.second_name, player?.web_name)}
      </span>
    );
  }
  return (
    <span
      className={cn(
        "inline-block rounded-full overflow-hidden border border-totem-border",
        showRing && "ring-2 ring-totem-gold ring-offset-2 ring-offset-totem-bg",
        className
      )}
      style={{ ...style, background: bg }}
    >
      <img
        src={url}
        alt={player?.web_name}
        width={size}
        height={size}
        onError={() => setError(true)}
        className="w-full h-full object-cover object-top"
      />
    </span>
  );
}
